import { parse } from 'query-string';
import { includes } from 'lodash-es';
import { useLocation } from 'react-router-dom';
import dayjs from '@/services/tools/dayjs';
import { SHORT_DATE_FORMAT, TIME_RANGES } from '@/services/constants';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';

export const useDateDropdownValue = (
    shouldReturnTimeRangeString: boolean,
    defaultValue: string | number = DateDropdownOptions.All,
    timeRanges?: number[]
): number | string => {
    const location = useLocation();
    const query = parse(location.search);
    const timeRangesValues = timeRanges ? timeRanges : TIME_RANGES;

    if (query.from && query.to) {
        const from = dayjs(query.from as string, SHORT_DATE_FORMAT);
        const to = dayjs(query.to as string, SHORT_DATE_FORMAT);
        const datesDiff = to.diff(from, 'day');

        if (includes(timeRangesValues, datesDiff) && dayjs().isSame(to, 'day')) {
            return shouldReturnTimeRangeString ? datesDiff.toString() : datesDiff;
        } else {
            return DateDropdownOptions.Calendar;
        }
    }

    if (query.dateFilter === DateDropdownOptions.All) return DateDropdownOptions.All;

    return defaultValue;
};
